<style lang="less" scoped>
/deep/.el-tabs__nav>.el-tabs__item{padding: 0px !important;}
/deep/.el-tabs__item {width: 120px;font-size: 14px;padding: 0px;}
</style>

<template>
  <div>
    <el-tabs v-model="editableTabsValue" type="card">
      <el-tab-pane label='法律内容列表' name='1'>
        <FlserverList :userdata='userdata'></FlserverList>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/**
 * 李旭
 * 后台法律管理页面
 */
import FlserverList from '../assembly/FlserverList.vue'
import {mapState} from 'vuex'
export default {
  props: ['userData'],
  components: {
    FlserverList
  },
  data()
  {
    return {
      editableTabsValue: '1',
      userdata: this.userData
    }
  },
  computed:
  {
    ...mapState({
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    IsLb:
    {
      handler(nval, oval)
      {
        this.editableTabsValue = nval
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/FlServer.vue